module.exports = __webpack_public_path__ + "img/automotive-banner.bae988df.jpg";